import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Multiselect, useMultiselectContext } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

type DoctorsFilterListProps = {
   readonly doctors: DoctorSimple[];
};

export const DoctorsFilterList = (props: DoctorsFilterListProps): JSX.Element => {
   const { searchText } = useMultiselectContext();
   const getDoctorName = (doctor: DoctorSimple): string => `${doctor.lastName} ${doctor.firstName}`;
   const filteredDoctors = props.doctors.filter((doctor) =>
      searchText ? getDoctorName(doctor).toLowerCase().includes(searchText.toLowerCase()) : true
   );

   return (
      <>
         <Multiselect.SelectAll<DoctorSimple>
            testId={'selectAll'}
            items={filteredDoctors}
            selectAllLabel={appointmentsTranslationKeys.filters.allSpecialists}
            searchInputEnabled
         />
         {filteredDoctors?.length === 0 ? (
            <Multiselect.NoItems testId={'noItems'} />
         ) : (
            <Multiselect.List<DoctorSimple> items={filteredDoctors} keyExtractor={'practitionerId'}>
               {(doctor) => (
                  <Multiselect.Item
                     item={doctor}
                     label={<Multiselect.Highlight node={createTranslatedText(getDoctorName(doctor))} />}
                     testId={doctor.id}
                  />
               )}
            </Multiselect.List>
         )}
      </>
   );
};
